
//import utils from '@/lib/utils'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
import { ConfigNodeInsertInfo } from '../types'

@Component({
  computed: {
    ...mapGetters({
      getNodeByName: 'getNodeByName',
      getConfigNodesMap: 'getConfigNodesMap',
      getDarkMode: 'getDarkMode',
      getIDCounter: 'getIDCounter',
      getModulesInsertInfo: 'getModulesInsertInfo',
      getSelectedNodeChildren: 'getSelectedNodeChildren',
      getTopLevelNodeNameReferenceIDsMap: 'getTopLevelNodeNameReferenceIDsMap',
    }),
    // ...mapState('sequence', ['sequences']),
  },
  methods: {
    ...mapActions({
      insertNodeReferencesOrClone: 'insertNodeReferencesOrClone',
      setSelectedNodeViaID: 'setSelectedNodeViaID',
      setSnackBarText: 'setSnackBarText',
      incrementIDCounter: 'incrementIDCounter',
      addNode: 'addNode',
      createObjectReferences: 'createObjectReferences',
      renameNode: 'renameNode',
      deleteNode: 'deleteNode',
    }),
  },
})
export default class TreeViewRightClick extends Vue {
  @Prop(String) readonly rightClickNodeType!: string
  @Prop(Number) readonly rightClickNodeId!: number
  @Prop(Boolean) readonly showMenu!: boolean
  @Prop(Number) readonly x!: number
  @Prop(Number) readonly y!: number

  @Watch('getIDCounter')
  // eslint-disable-next-line no-unused-vars
  onIDCounterChanged(val: any, oldVal: any) {
    /*    console.log('getIDCounter from right click VAL:' + val)
    console.log('getIDCounter from right click OLDVAL: ' + oldVal) */
  }

  @Watch('showMenu')
  // eslint-disable-next-line no-unused-vars
  onShowMenuChanged(val: any, oldVal: any) {
    //console.log('showMenu NEW VAL:' + val)
    //console.log('showMenu OLDVAL: ' + oldVal)
  }

  @Watch('selectedNodes')
  // eslint-disable-next-line no-unused-vars
  onSelectedNodesChanged(val: any, oldVal: any) {
    //set already exists to true if the node is already inside selected node children
    let selectedNodeChildren = this.getSelectedNodeChildren
    if (selectedNodeChildren == undefined) return
    for (let i = 0; i < selectedNodeChildren.length; i++) {
      for (let j = 0; j < this.selectedNodes.length; j++) {
        if (selectedNodeChildren[i]['rootNodeId'] == this.selectedNodes[j].id)
          this.selectedNodes[j].nodeAlreadyExists = true
      }
    }
    //console.log('selectedNodes NEW VAL:' + JSON.stringify(val))
    //console.log('selectedNodes OLDVAL: ' + JSON.stringify(oldVal))
  }

  private getNodeByName!: any

  //store actions
  private insertNodeReferencesOrClone!: (payload: Array<Object>) => Promise<any>
  private setSelectedNodeViaID!: (payload: {
    selectedNodeId: number
    forceOpenNode: boolean
  }) => Promise<any>
  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private incrementIDCounter!: () => Promise<any>
  private createObjectReferences!: () => Promise<any>
  private addNode!: (payload: {
    nodeId: number
    nodeIDToObject: Object
  }) => Promise<any>
  private renameNode!: (payload: {
    newNodeName: string
    rootNodeId: number
  }) => Promise<any>
  private deleteNode!: (payload: {
    oldSequenceName: string
    nodeId: number
  }) => Promise<any>

  //store getters
  private getConfigNodesMap!: Object
  private getIDCounter!: number
  private getModulesInsertInfo!: Array<ConfigNodeInsertInfo>
  private getSelectedNodeChildren!: Array<Object>
  private getTopLevelNodeNameReferenceIDsMap!: Object

  private menuItems: any = [
    [
      //main sequence node
      ['Add Sequence', 'Separator', true],
      ['Remove Unreferenced Sequences', 'No Separator'],
      ['Resolve Unnecessary Sequences', 'Separator'],
      ['Sort', 'No Separator'],
    ],
    [
      //sequence node
      ['Add Module', 'No Separator'],
      ['Add Sequence', 'No Separator'],
      ['Add Task', 'No Separator'],
      ['Add SwitchProducer', 'Separator'],
      ['Rename Sequence', 'No Separator'],
      ['Clone Sequence', 'No Separator'],
      ['Deep Clone Sequence', 'No Separator'],
      ['Remove Sequence', 'No Separator'],
      ['Replace Sequence', 'No Separator'],
    ],
    [
      //main path node
      ['Add Path', 'Seprator'],
      ['Sort', 'No Seprator'],
    ],
    [
      //path node
      ['Add Module', 'No Separator'],
      ['Add Path', 'No Separator'],
      ['Add Sequence', 'No Separator'],
      ['Add Task', 'No Separator'],
      ['Add SwitchProducer', 'Separator'],
      ['Remove Path', 'No Separator'],
      ['Clone Path', 'Separator'],
      ['Assign to P. Dataset', 'No Separator'],
      ['Remove from P. Dataset', 'Separator'],
      ['endpath', 'No Separator'],
      ['Replace Path', 'No Separator'],
    ],
    [
      //main modules node
      ['Sort', 'No Seprator'],
    ],
    [
      //module node
      ['Rename Module', 'No Seprator'],
      ['Replace Module', 'No Seprator'],
    ],
    [
      //main PSet node
      ['Add PSet', 'No Seprator'],
    ],
    [
      //PSet node
      ['Add PSet', 'No Seprator'],
      ['Remove PSet', 'No Seprator'],
    ],
  ]

  private subMenuItems: Object = {
    'Add Module': ['Add module from config', 'Add module from the templates'],
  }

  private dialog: boolean = false //regular dialog for adding new/removing/renaming sequences etc.
  private dialogHeader: string = ''
  private dialogText: string = ''
  private dialogValue: string = ''
  private enterText: boolean = false

  private dialogList: boolean = false //list dialog containing node entries to be added to a particular node
  private dialogListHeader: string = ''
  //private rootNodeId: number = -1
  private selectedNodes: Array<ConfigNodeInsertInfo> = []

  private actionCallBack!: (...args: any[]) => void
  private actionListCallBack!: (...args: any[]) => boolean

  get getMenuItems() {
    //TODO CHANGE THIS INTO NORMAL MAP
    console.log('RIGHT CLICK NODE TYPE: ' + this.rightClickNodeType)
    //console.log('this.menuItems[0]: ' + this.menuItems[0])
    if (this.rightClickNodeType == 'seqs') return this.menuItems[0]
    else if (this.rightClickNodeType == 'sequences') return this.menuItems[1]
    else if (this.rightClickNodeType == 'pts') return this.menuItems[2]
    else if (this.rightClickNodeType == 'paths') return this.menuItems[3]
    else if (this.rightClickNodeType == 'mods') return this.menuItems[4]
    else if (this.rightClickNodeType == 'modules') return this.menuItems[5]
    else if (this.rightClickNodeType == 'psets') return this.menuItems[6]
    else if (this.rightClickNodeType == 'pset') return this.menuItems[7]
    //return this.menuItems[nodeType]
    return []
  }

  public remove(item: ConfigNodeInsertInfo) {
    const index = this.selectedNodes.indexOf(item)
    if (index >= 0) this.selectedNodes.splice(index, 1)
  }

  public checkIfNodeExists(id: number) {
    //console.log('NODE NAME: ' + name)
    let selectedNodeChildren = this.getSelectedNodeChildren
    //another loop to set exist flag in the selected nodes
    for (let i = 0; i < selectedNodeChildren.length; i++) {
      if (selectedNodeChildren[i]['rootNodeId'] == id) {
        return 'red'
      }
    }
    return 'green'
  }

  //prevent textfield auto focus propagation
  public preventTextFieldPropagation(e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  // eslint-disable-next-line no-unused-vars
  public clickAction(e: Event, actionName: string) {
    console.log('ACTION NAME: ' + actionName)
    console.log('NODE TYPE: ' + this.rightClickNodeType)
    console.log('NODE ID: ' + this.rightClickNodeId)
    e.preventDefault() //prevent context menu from closing if action is clicked
    e.stopPropagation()
    //TODO: handle right clicks properly depending on node type
    if (this.rightClickNodeType == 'seqs') {
      if (actionName == 'Add Sequence') {
        console.log('Add Sequence')
        this.dialog = true
        this.dialogHeader = 'Sequence name:'
        this.dialogText = ''
        this.enterText = true
        this.actionCallBack = this.insertSequence
      } else if (actionName == 'Remove Unreferenced Sequences') {
        //TODO
        console.log('Remove Unreferenced Sequences')
      } else if (actionName == 'Resolve Unnecessary Sequences') {
        //TODO
        console.log('Resolve Unnecessary Sequences')
      } else if (actionName == 'Sort') {
        //TODO
        console.log('Sort')
      }
    } else if (this.rightClickNodeType == 'sequences') {
      if (actionName == 'Add Module') {
        console.log('Add Module')
      } else if (actionName == 'Add Sequence') {
        //TODO
        console.log('Add Sequence')
      } else if (actionName == 'Add Task') {
        //TODO
        console.log('Add Task')
      } else if (actionName == 'Add SwitchProducer') {
        //TODO
        console.log('Add SwitchProducer')
      } else if (actionName == 'Rename Sequence') {
        //console.log('Rename Sequence')
        this.dialog = true
        this.dialogHeader = 'New sequence name:' //TODO FIX MODAL FOR RENAME
        this.dialogText = ''
        this.enterText = true
        this.actionCallBack = this.renameSequence
      } else if (actionName == 'Clone Sequence') {
        //TODO
        console.log('Clone Sequence')
      } else if (actionName == 'Deep Clone Sequence') {
        //TODO
        console.log('Deep Clone Sequence')
      } else if (actionName == 'Remove Sequence') {
        //TODO
        console.log('Remove Sequence')
        let rootNodeId = this.getConfigNodesMap[this.rightClickNodeId]
          .rootNodeId
        let sequenceName = this.getConfigNodesMap[rootNodeId].name
        let referencesNumber = this.getTopLevelNodeNameReferenceIDsMap[
          sequenceName
        ].size

        this.enterText = false
        this.dialog = true
        this.dialogHeader = ''
        this.dialogText =
          'Do you really want to remove ' +
          sequenceName +
          ', which is referenced ' +
          referencesNumber +
          ' times?' //TODO FIX MODAL FOR RENAME

        this.actionCallBack = this.deleteSequence
      } else if (actionName == 'Replace Sequence') {
        //TODO
        console.log('Replace Sequence')
      }
    }
  }

  async clickSubAction(e: Event, subMenuItem: string) {
    e.preventDefault() //prevent context menu from closing if action is clicked
    e.stopPropagation()
    //console.log('ROOT NODE ID: ' + nodeBasicInfo.id)
    //console.log(subMenuItem + ' called')
    if (subMenuItem == 'Add module from config') {
      //
      this.dialogList = true
      this.dialogListHeader = 'Modules list:'
      this.actionListCallBack = this.insertStoreNodeReference
    }
  }

  public insertStoreNodeReference(): boolean {
    //first check if any node existis and prevent adding of all nodes if it's not cloned
    for (let i = 0; i < this.selectedNodes.length; i++) {
      if (
        !this.selectedNodes[i].clone &&
        this.selectedNodes[i].nodeAlreadyExists
      ) {
        //Display snackbar error
        this.setSnackBarText({
          snackBarText:
            'Node(s) cannot be inserted as they already exist. Tick the clone option!',
          snackBarColor: 'red',
        })
        return false
      }
      //console.log('NODE TYPE: ' + this.selectedNodes[i].type)
      //console.log('NODE CLONE NAME: ' + this.selectedNodes[i].cloneName)
      //if there is even a node with the same clone name it cannot be inserted
      if (
        this.selectedNodes[i].clone &&
        this.getNodeByName(
          this.selectedNodes[i].type,
          this.selectedNodes[i].cloneName
        ) != undefined
      ) {
        //Display snackbar error
        this.setSnackBarText({
          snackBarText:
            'Node(s) cannot be clone as clone name already exists. Change the clone name first!',
          snackBarColor: 'red',
        })
        return false
      }
    }
    /* 
    let t0 = performance.now()
 */

    let payloadArray: Array<Object> = []
    for (let i = 0; i < this.selectedNodes.length; i++) {
      //console.log('NODE TO INSERT:' + JSON.stringify(this.selectedNodes[i]))
      if (!this.selectedNodes[i].clone) {
        payloadArray.push({
          parentId: this.rightClickNodeId,
          rootNodeId: this.selectedNodes[i].id,
          cloneName: '',
        })
      } else {
        payloadArray.push({
          parentId: this.rightClickNodeId,
          rootNodeId: this.selectedNodes[i].id,
          cloneName: this.selectedNodes[i].cloneName,
        })
      }
    }
    //console.log('AAAAAAAAA')
    Promise.resolve(this.insertNodeReferencesOrClone(payloadArray)).finally(
      () => {
        this.createObjectReferences() //recreate map references since map has been copied

        this.setSelectedNodeViaID({
          selectedNodeId: this.getIDCounter,
          forceOpenNode: true,
        })

        //Display snackbar success
        this.setSnackBarText({
          snackBarText: 'Node(s) successfuly inserted!',
          snackBarColor: 'green',
        })
      }
    )

    /*     let t1 = performance.now()
    console.log(
      'insertStoreNodeReference TOOK: ' + Math.round(t1 - t0) + ' milliseconds'
    ) */

    return true
  }

  // eslint-disable-next-line no-unused-vars
  async insertSequence() {
    //sequenceNodeId is not used for new node
    let sequenceName = this.dialogValue
    //console.log('TRYING TO INSERT SEQUENCE ' + sequenceName)
    //first check if there is sequence with the same name
    if (this.getNodeByName('sequences', sequenceName) == undefined) {
      Promise.resolve(this.incrementIDCounter()).finally(() => {
        let newSequenceId = this.getIDCounter
        //console.log('NEW SEQUENCE ID: ' + newSequenceId)
        /*    console.log(
          'GETIDCOUNTER NODE: ' +
            JSON.stringify(this.getConfigNodesMap[newSequenceId])
        ) */
        let newSequenceObject: Object = {
          id: newSequenceId,
          name: sequenceName,
          type: 'sequences',
          children: [],
          parentNodeId: 1,
          rootNodeId: newSequenceId, //new sequence is it's own root
        }

        Promise.resolve(
          //set new object into main map
          this.addNode({
            nodeId: newSequenceId,
            nodeIDToObject: newSequenceObject,
          })
          //Focus and open/active new node
        ).finally(() => {
          //console.log('ADDITION DONE!')
          //this.createObjectReferences() //recreate map references since map has been copied
          this.setSelectedNodeViaID({
            selectedNodeId: this.getIDCounter,
            forceOpenNode: true,
          })
          //Display snackbar success
          this.setSnackBarText({
            snackBarText: 'Sequence successfully created!',
            snackBarColor: 'green',
          })
        })
      })
    } else {
      await this.setSnackBarText({
        snackBarText: 'ERROR: There is sequence with the same name!',
        snackBarColor: 'red',
      })
    }
  }

  // eslint-disable-next-line no-unused-vars
  async renameSequence() {
    //console.log('TRYING TO RENAME SEQUENCE ' + newSequenceName)
    let newSequenceName = this.dialogValue
    let sequenceNodeRootId = this.getConfigNodesMap[this.rightClickNodeId]
      .rootNodeId
    //first check if there is sequence with the same name
    if (this.getNodeByName('sequences', newSequenceName) == undefined) {
      Promise.resolve(
        this.renameNode({
          newNodeName: newSequenceName,
          rootNodeId: sequenceNodeRootId,
        })
      ).finally(() => {
        //console.log('RENAMING DONE!')
        this.createObjectReferences() //recreate map references since map has been copied
        this.setSnackBarText({
          snackBarText: 'Sequence successfully renamed!',
          snackBarColor: 'green',
        })
      })
    } else {
      await this.setSnackBarText({
        snackBarText: 'ERROR: There is sequence with the same name!',
        snackBarColor: 'red',
      })
    }
  }

  // eslint-disable-next-line no-unused-vars
  async deleteSequence() {
    let oldSequenceName = this.dialogValue
    //let sequenceNodeId = this.rightClickNodeId

    //console.log('TRYING TO DELETE SEQUENCE ' + oldSequenceName)
    let rootNodeId = this.getConfigNodesMap[this.rightClickNodeId].rootNodeId

    /*     console.log('rootNodeId ' + rootNodeId)
    console.log('this.rightClickNodeId ' + this.rightClickNodeId) */

    Promise.all([
      this.deleteNode({
        oldSequenceName: oldSequenceName,
        nodeId: rootNodeId,
      }),
    ]).finally(() => {
      //console.log('DELETING DONE!')
      this.createObjectReferences() //recreate map references since map has been copied
      this.setSnackBarText({
        snackBarText: 'Sequence successfully deleted!',
        snackBarColor: 'green',
      })
    })
  }

  async okClicked() {
    //console.log('DIALOG VALUE: ' + this.dialogValue)
    this.actionCallBack()
    this.dialog = false
    this.selectedNodes = []
  }

  public cancelClicked() {
    this.dialog = false
    //console.log('CANCEL CLICKED')
    this.selectedNodes = []
  }

  async okListClicked() {
    //console.log('OBJ: ' + JSON.stringify(this.selectedNodes))
    let success = this.actionListCallBack()
    if (success) {
      this.dialogList = false
      this.selectedNodes = []
    }
  }

  async cancelListClicked() {
    this.dialogList = false
    this.selectedNodes = []
  }

  public onKeyDown(e) {
    if (e.key == 'Escape') {
      if (this.dialog) {
        this.cancelClicked()
      }
      if (this.dialogList) {
        this.cancelListClicked()
      }
      // or if you have created a dialog as a custom component, emit an event
      // this.$emit('closeDialog')
    } else if (e.key == 'Enter') {
      if (this.dialog) this.okClicked()
      if (this.dialogList) this.okListClicked()
    }
  }

  mounted() {
    document.addEventListener('keydown', this.onKeyDown)
    //const ac = this.$refs.aaa as HTMLElement
    //ac.addEventListener('blur', this.doSomething, true)
    //console.log(document.getElementById('autoComplete_id'))
    //console.log(this.$refs.testRef)
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown)
  }
}
